/**
 * Route prefixes that stay accessible on mobile even though the rest of the
 * authenticated app is blocked below the mobile breakpoint (see useMobile).
 *
 * Billing is allowed so an out-of-office admin/finance user can recharge from a
 * phone and unblock their team. Add more prefixes here to widen the carve-out.
 */
export const MOBILE_ALLOWED_ROUTE_PREFIXES = ['/billing'] as const

/**
 * Whether the given pathname may be used on mobile. Strips the optional '/api'
 * API-console prefix (see usePrefixedPath) before matching so both '/billing'
 * and '/api/billing' resolve the same.
 */
export const isMobileAllowedPath = (pathname: string): boolean => {
  const normalized = pathname.startsWith('/api/') ? pathname.slice(4) : pathname
  return MOBILE_ALLOWED_ROUTE_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
  )
}
